<div class="row ss-top-menu">
  <div class="col-sm-3">
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Dashboard <i
        class="rightArrow fa fa-angle-right"></i></span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Promo Packages</span>
  </div>
  <div class="col-sm-9  text-right d-flex">
    <div class="pop mr-3" (mouseenter)="openpopup($event)" title="Download Promo Package Report" style="width: 64px;">
      <i class="cursor-pointer fa fa-download pr-3 pt-2" style="font-size:24px;color: #8f265c"
        (click)="downloadPromoPackages()"></i>
    </div>
    <button class="downloadBtn btn mr-3" data-toggle="modal" data-target="#promoCodeModal" (click)="clearEditPromoId()">
      Create New Promo Package
    </button>
    <div class="ss-searchbox w-100">
      <i class="fa fa-search"></i>
      <input class="" type="text" placeholder="Search by Name or Code" id="serachPromo">
    </div>
    <button class="addCursor h-100 ml-4 rk-interalBtnColor" (click)="searchPromo()">GO</button>
  </div>
</div>

<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="mt-4 container-set">
  <div class="row">
    <div class="col-md-12" *ngIf="lead_priority_que_arr &&  lead_priority_que_arr.length>0">
      <div class="tableDiv table-responsive">
        <div class="tableDiv">

          <table class="table">
            <thead>
              <tr>
                <th class="text-center firstTh">#</th>
                <th>Code</th>
                <th>Name and Desc</th>
                <th>Value</th>
                <th>Threshold</th>
                <th>Expiry Date</th>
                <th>No. of BOQs Shared <br> with this Promo</th>
                <th>10% Payment <br> Closure Nos</th>
                <th>40% Payment <br> Closure Nos</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let data of lead_priority_que_arr  | paginate: { itemsPerPage: per_page, currentPage: current_page, totalItems: total_page  } let i = index;"
                [attr.data-index]="i">
                <td class="text-center">{{i+1}}</td>
                <td class="">{{data.code}}</td>
                <td class="capitalize minWidthForTd">
                  <p *ngIf="data.name == null || data.name=='' ">Unnamed</p>
                  <p *ngIf="data.name!=null && data.name!='' " class="pop nameField" (mouseenter)="openpopup($event)"
                    title={{data.description}}>{{data.name}}</p>
                </td>
                <td class="minWidthForTd">{{data.promo_display_value}}</td>
                <td>{{data.threshold}}</td>
                <td>{{data.expiry_date ? (data.expiry_date | date:'dd/MM/yyyy') : '-' }}</td>
                <td>{{data.number_boqs_shared}}</td>
                <td>{{data.number_boqs_10_percent_payment}}</td>
                <td>{{data.number_boqs_40_percent_payment}}</td>

                <td>
                  <select class="text-capitalize" (change)="changeStatus(data.id, $event.target.value)">
                    <option class="text-capitalize" value={{item}} [selected]="data.status==item"
                      *ngFor="let item of statusList">{{item}}
                    </option>
                  </select>
                </td>
                <td>
                  <button class="downloadBtn btn" (click)="fetchPromoDetails(data.id)" data-toggle="modal"
                    data-target="#promoCodeModal">
                    <i class="fa fa-pencil"></i> 
                    <!-- Edit -->
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="lead_priority_que_arr && lead_priority_que_arr.length >0">
          <pagination-controls autoHide="true" (pageChange)="current_page = getPromoPackages($event,'','')">
          </pagination-controls>
        </div>
      </div>
    </div>
    <div class="col-md-12 not-found " *ngIf="lead_priority_que_arr && lead_priority_que_arr.length==0 ">
      <div class="boq-img text-center">
        <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
      </div>
      <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">No Packages to display...</p>
    </div>
  </div>
</div>


<!-- The Modal -->
<div class="modal" id="promoCodeModal">
  <div class="modal-dialog" style="max-width: 74%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title text-center w-100">Create New Promo Package</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body pt-4 pl-5">
        <div class="row">
          <div class="col-md-12">
            <form class="viewProfileForm" [formGroup]="promoPackagesForm">
              <div class="row justify-content-center">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-6">
                        <label>Package Name*</label>
                        <input type="text" class="form-control" placeholder="Enter Package Name" id="name" required
                        name="name" formControlName="name" />
                      <div
                        *ngIf="promoPackagesForm.controls['name'].errors && !promoPackagesForm.controls['name'].pristine"
                        class="text-danger">
                      </div>
                      </div>
                      <div class="col-6">
                        <label>Promo Code*</label>
                        <input type="text" pattern="" class="form-control" placeholder="Enter Promo Code" id="code"
                        required name="promo_code" formControlName="promo_code" />
                      <div class="text-danger">{{validPromo}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-6">
                        <label>Promo Description*</label>
                        <textarea type="text" class="form-control text-capitalize" id="code" required name="description"
                        formControlName="description" rows="4" cols="50">
                        </textarea>
                      <div
                        *ngIf="promoPackagesForm.controls['description'].errors && !promoPackagesForm.controls['description'].pristine"
                        class="text-danger">
                      </div>
                      </div>
                      <div class="col-6">
                        <label>Promo Remark*</label>
                        <textarea class="form-control" id="remarks" required name="remarks" formControlName="remarks"
                        rows="4" cols="50">
                        </textarea>
                      <div
                        *ngIf="promoPackagesForm.controls['remarks'].errors && !promoPackagesForm.controls['remarks'].pristine"
                        class="text-danger">
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-6">
                        <label>Promo Value*</label>
                        <input type="number" class="form-control text-capitalize" placeholder="Enter Promo Value"
                        id="value"  name="promo_value" formControlName="promo_value" />
                        <!-- <div class="text-danger">{{validPromoDiscount}}</div> -->
                      <!-- <div
                        *ngIf="promoPackagesForm.controls['promo_value'].errors && !promoPackagesForm.controls['promo_value'].pristine"
                        class="text-danger">
                      </div> -->
                      </div>
                      <div class="col-6">
                        <label>Discount % </label>
                        <input type="number" class="form-control text-capitalize" placeholder="Enter Promo Discount Percent"
                        id="value"  name="promo_discount_percent" formControlName="promo_discount_percent" />
                        <!-- <div class="text-danger">{{validPromoDiscount}}</div> -->
                        
                        <!-- <div  *ngIf="!promoPackagesForm.controls['promo_value'].value">
                          <div 
                          *ngIf="promoPackagesForm.controls['promo_discount_percent'].errors && !promoPackagesForm.controls['promo_discount_percent'].pristine"
                          class="text-danger">
                        </div>
                        </div> -->
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-6">
                        <label>Promo Threshold*</label>
                        <input type="number" class="form-control text-capitalize" placeholder="Enter Promo Threshold"
                        id="threshold" required name="promo_threshold" formControlName="promo_threshold" />
                      <div
                        *ngIf="promoPackagesForm.controls['promo_threshold'].errors && !promoPackagesForm.controls['promo_threshold'].pristine"
                        class="text-danger">
                      </div>
                      </div>
                      <div class="col-6">
                        <label>Promo Code Expiry Date</label>
                        <input type="date" id="txtDate" name="txtDate" class="form-control"
                          formControlName="expiry_date" placeholder="Select Promo Package" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                 <div class="row">
                  <div class="col-12 d-flex">
                    <div class="mb-2" *ngIf="imageUrl">
                      <img class="img-fluid" src={{imageUrl}} *ngIf="imageUrl" style="height: 15rem;" />
                    </div>
                    <input class="" type="file" id="uploadImage" accept="image/jpeg,image/png" (change)="uploadImage($event)"
                      style="display: none" />
                    <img src="../../assets/img/tray-arrow-up.png"
                      (click)="activeUploadImage()" />
                    <div class="ml-3 my-2">Upload Image</div>
                  </div>
                 </div>
                 <div class="row">
                <div class="col-12 text-center mb-2">
                  <button class="btn mt-3 downloadBtn" type="submit" [disabled]="!promoPackagesForm.valid"
                    *ngIf="this.edited_promo_code == null" (click)="onSubmit(promoPackagesForm.value)">
                    Submit
                  </button>
                  <!-- -------------------------------------- -->
                  <button class="btn mt-3 downloadBtn" type="submit" [disabled]="!promoPackagesForm.valid"
                    *ngIf="this.edited_promo_code" (click)="update(promoPackagesForm.value)">
                    Update
                  </button>
                </div>
              </div>
            </form>   
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/promo-packages/promo-packages.component.html